import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getCurrentOrganization } from '../utils/organizationContext';

const SubmissionSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { organizationSlug: urlSlug } = useParams();
  const { organizationSlug } = useAuth();
  
  // Get organization slug from URL params (most reliable)
  // Fallback to context or parsing from pathname
  const currentOrgSlug = urlSlug || organizationSlug || getCurrentOrganization() || 
    (location.pathname.split('/').filter(Boolean)[0] || null);
  
  // Determine redirect path based on organization context
  const handleSubmitAnother = () => {
    // Always try to go back to the first timer form for the current organization
    if (currentOrgSlug) {
      navigate(`/${currentOrgSlug}/add-first-timer`, { replace: true });
    } else {
      // Fallback: go to welcome page
      navigate('/', { replace: true });
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 4, textAlign: 'center' }}>
        <CheckCircleOutline 
          color="success" 
          sx={{ fontSize: 64, mb: 2 }} 
        />
        <Typography variant="h5" gutterBottom>
          Thank you for joining us today!
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          Your information has been submitted and we will reach out to check in on you.
        </Typography>
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmitAnother}
            size="large"
          >
            Submit Another Record
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default SubmissionSuccess; 